import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import CampanaNotificacionesListItem from './Components/CampanaNotificacionesListItem';
import { fetchTotalNotificaciones } from '../../../actions/notificacionesActions';
import ClickOutsideHandler from '../../General/ClickOutsideHandler';
import './Styles/CampanaNotificaciones.css'

const tiempoActualizacion = 420000 //=> CADA 7 MINUTOS

class CampanaNotificaciones extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hideNotificaciones: true
    };
  }

  componentDidMount() {
    this.obtenerTotalNotificaciones();
    this.interval = setInterval(() => {
      this.obtenerTotalNotificaciones();
    }, tiempoActualizacion);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  obtenerTotalNotificaciones() {
    this.props.fetchTotalNotificaciones({
      idSeller: this.props.idSeller, 
      tipoUsuario: this.props.tipoUsuario
    });
  }

  ocultarNotificaciones = () => {
    this.setState({ hideNotificaciones: true });
  }


  render = () => {

    const { hideNotificaciones } = this.state;
    let notificaciones = this.props.totalNotificaciones;

    const cantidadNotificaciones = [
      {label: 'Cambios de stock', cantidad: notificaciones.cambiosStock},
      {label: 'Cambios de precio', cantidad: notificaciones.cambiosPrecios},
      {label: 'Órdenes nuevas', cantidad: notificaciones.ordenesNuevas},
      {label: 'Órdenes anuladas', cantidad: notificaciones.ordenesAnuladas},
      {label: 'Modificaciones de cuotas', cantidad: notificaciones.modificacionesCuotas}
    ]

    return (
      <div className="bell-container prevent-select">

        <a onClick={() => this.setState({ hideNotificaciones: !hideNotificaciones })}>
          <ul className="nav navbar-nav m-auto align-items-center color-blanco-megatone">

            <li className="nav-item d-flex">
              <i 
                className={`mdi mdi-bell${notificaciones.notificaciones === null ? "-off" : ""}`} 
                style={{ fontSize: '1.8rem' }}
              />
            </li>
            
            <span className="badge rounded-pill bell-badge" hidden={notificaciones.notificaciones === 0}>
              +{notificaciones.notificaciones}
            </span>

          </ul>
        </a>

        {!hideNotificaciones && (
          <ClickOutsideHandler onClickOutside={this.ocultarNotificaciones}>
            <div className="card-notificaciones item-popout animated headShake">

              <div className="row justify-content-between align-items-center">

                <div className="col-auto">
                  <span className="mx-2 font-size-072rem">Notificaciones</span>
                </div>

                <div className="col-auto">
                  <NavLink 
                    to="/Notificaciones/Ajustes" 
                    aria-expanded="false"
                    onClick={this.ocultarNotificaciones}
                  >
                    <i className="color-gris-megatone mdi mdi-settings hover-background-color rounded-pill mx-2"/>
                  </NavLink>
                </div>

              </div>

              {
                cantidadNotificaciones.map((notificacion, i) => {
                  return (
                    <div 
                      key={i}
                      hidden={
                        this.props.tipoUsuario === 3 && notificacion.label === 'Órdenes Anuladas' ||
                        this.props.tipoUsuario === 4 && notificacion.label === 'Órdenes Anuladas' ||
                        notificacion.cantidad === 0 || notificacion.cantidad == undefined
                      }
                    >
                      <CampanaNotificacionesListItem 
                        nombre={notificacion.label} 
                        cantidad={notificacion.cantidad} 
                      />
                    </div>
                  )
                })
              }

              <div className="border-top" hidden={notificaciones.notificaciones > 0}>
                <div className="d-flex justify-content-center">
                  <i className="color-gris-megatone sl-icon-check p-4" style={{ fontSize: "5rem" }}/>
                  <span className="text-dark p-4">No hay notificaciones pendientes</span>
                </div>
              </div>

              <NavLink 
                to="/Notificaciones" 
                aria-expanded="false"
                onClick={this.ocultarNotificaciones}
              >
                <div className="hover-background-color">
                  <div className="d-flex justify-content-center border-top">
                    <span className="text-dark">Ver todo</span>
                  </div>
                </div>
              </NavLink>

            </div>
          </ClickOutsideHandler>
        )}

      </div>
    );
  };
}


const mapStateToProps = state => ({
  tipoUsuario: state.general.tipoUsuario,
  idSeller: state.general.idSeller,
  totalNotificaciones: state.notificaciones.total
});

export default connect(mapStateToProps, { fetchTotalNotificaciones }) (CampanaNotificaciones);